import React from 'react';
import { Box, TableContainer, Table, TableBody, Grid, TableHead, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { Styles, ProvisionStyledTableCell, ProvisionStyledTableRow, ProvisionActionStyledTableRow } from 'pages/myidm/style';
import { OrderPayload } from 'pages/myidm/store';
import FormCard from 'pages/myidm/components/form-card';
import { PRIVILEGED } from 'pages/myidm/utils/constant';
import { CancelRequest } from '../../CancelRequest';
import { SubmitRequest } from '../../SubmitRequest';

const MultipleMemberslList = () => {
    const [order] = useRecoilState(OrderPayload);
    return (
        <Grid item borderRadius={1.5} md={12}>
            <Box>
                <FormCard title="Add Members" gap={0} padding={2} margin={2}>
                    {/* Check if all groups have no members */}
                    {order?.multipleAdGroups?.length > 0 && order.multipleAdGroups.every((g) => !g.members || g.members.length === 0) ? (
                        <TableContainer sx={Styles?.ProvisionAddMemberForm?.table.tableWrapper}>
                            <Table sx={{ ...Styles?.ProvisionAddMemberForm?.table?.main, height: 'auto' }} size="small" stickyHeader>
                                <TableBody>
                                    <ProvisionActionStyledTableRow>
                                        <ProvisionStyledTableCell>No members selected.</ProvisionStyledTableCell>
                                    </ProvisionActionStyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        (order?.multipleAdGroups || []).map((group, idx) =>
                            group?.adGroup ? (
                                <Box key={`adgroup-section-${idx}`} sx={{ mb: 4, width: '100%' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 2 }}>
                                            <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Group Name:</Typography>
                                            {group?.adGroup || '-'}
                                        </Box>
                                        {group?.members?.length ? (
                                            <Box>
                                                <b>{group?.members?.length}</b> Member(s) selected
                                            </Box>
                                        ) : null}
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Is Privileged Active Directory Group:</Typography>
                                        {group?.adGroupType === PRIVILEGED ? 'Yes' : 'No'}
                                    </Box>
                                    <TableContainer sx={Styles?.ProvisionAddMemberForm?.table.tableWrapper}>
                                        <Table sx={{ ...Styles?.ProvisionAddMemberForm?.table?.main, height: 'auto' }} size="small" stickyHeader>
                                            <TableHead>
                                                <ProvisionActionStyledTableRow>
                                                    <ProvisionStyledTableCell sx={{ padding: '10px !important', backgroundColor: '#E5F5FC !important' }}>
                                                        GPID
                                                    </ProvisionStyledTableCell>
                                                    <ProvisionStyledTableCell sx={{ padding: '10px !important', backgroundColor: '#E5F5FC !important' }}>
                                                        Full Name
                                                    </ProvisionStyledTableCell>
                                                    <ProvisionStyledTableCell sx={{ padding: '10px !important', backgroundColor: '#E5F5FC !important' }}>
                                                        Email ID
                                                    </ProvisionStyledTableCell>
                                                    {group?.adGroupType === PRIVILEGED && (
                                                        <ProvisionStyledTableCell sx={{ padding: '10px !important', backgroundColor: '#E5F5FC !important' }}>
                                                            Secondary Account
                                                        </ProvisionStyledTableCell>
                                                    )}
                                                </ProvisionActionStyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {group?.members?.length > 0 ? (
                                                    group.members.map((member) => (
                                                        <ProvisionStyledTableRow
                                                            className="animate-opacity"
                                                            key={member?.gpid}
                                                            data-testId="members-list-table"
                                                        >
                                                            <ProvisionStyledTableCell>{member?.gpid || ''}</ProvisionStyledTableCell>
                                                            <ProvisionStyledTableCell>{member?.name || '-'}</ProvisionStyledTableCell>
                                                            <ProvisionStyledTableCell>{member?.email || '-'}</ProvisionStyledTableCell>
                                                            {group?.adGroupType === PRIVILEGED && (
                                                                <ProvisionStyledTableCell>
                                                                    {member?.secondaryAccount?.secondaryAccountName || '-'}
                                                                </ProvisionStyledTableCell>
                                                            )}
                                                        </ProvisionStyledTableRow>
                                                    ))
                                                ) : (
                                                    <ProvisionStyledTableRow>
                                                        <ProvisionStyledTableCell colSpan={group?.adGroupType === PRIVILEGED ? 4 : 3}>
                                                            No members selected.
                                                        </ProvisionStyledTableCell>
                                                    </ProvisionStyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            ) : null
                        )
                    )}
                    {/* Show action buttons only if every group in multipleAdGroups has at least one member */}
                    {order?.multipleAdGroups?.length > 0 && order?.multipleAdGroups.every((g) => Array.isArray(g.members) && g.members.length > 0) && (
                        <Box display="flex" gap={1} sx={{ mb: 2, alignItems: 'baseline', justifyContent: 'flex-end', width: '100%' }}>
                            <Box sx={{ marginTop: '0px' }}>
                                <CancelRequest />
                            </Box>
                            <SubmitRequest />
                        </Box>
                    )}
                </FormCard>
            </Box>
        </Grid>
    );
};

export default MultipleMemberslList;
